import { colors } from '@guryou/colors';
import { EntityTypes } from '@guryou/core';

export const normalizeColor = (color, reservationType) => {
  if (!color) return 'var(--feel-primary)';

  let hexColor = color.startsWith('#') ? color : `#${color}`;
  let colorCode = hexColor.replace('#', '').toLowerCase();

  if (colorCode.length === 3) {
    colorCode = colorCode
      .split('')
      .map(char => char + char)
      .join('');
  }

  if (colorCode.length !== 6 || !/^[0-9a-f]{6}$/.test(colorCode)) {
    return 'var(--feel-primary)';
  }

  const r = parseInt(colorCode.substr(0, 2), 16);
  const g = parseInt(colorCode.substr(2, 2), 16);
  const b = parseInt(colorCode.substr(4, 2), 16);

  const isPurple =
    (r > 100 && b > 100 && g < Math.min(r, b) && (r + b) / 2 > g + 30) ||
    (colorCode.match(/^[89abcdef]/) && b > r && b > g) ||
    (r > 120 && b > 120 && g < 100 && Math.abs(r - b) < 50) ||
    hexColor.toLowerCase() === '#801ad8';

  if (isPurple) {
    if (reservationType === EntityTypes.course) {
      return colors.lightningYellow;
    } else if (reservationType === EntityTypes.event) {
      return colors.fruitSalad;
    } else {
      return 'var(--feel-primary)';
    }
  }

  return hexColor;
};
